import { Component, OnInit } from '@angular/core';
import { applyFroalaAriaFix, stripFroalaWatermark } from '../../utils/froala.utils';
import { SidePanelBase } from "../side-panel-base.class";
import { deepClone } from "../../../builder/models/editor.model";
import { AuthService } from "../../../services/auth.service";
import { NoteType } from "../../models/note-type.enum";
import { Note } from "../../models/note.model";

@Component({
    selector: 'review-notes-common',
    templateUrl: './review-notes-common.component.html',
    styleUrls: ['../notes/notes.component.scss', './review-notes-common.component.scss'],
    standalone: false
})
export class ReviewNotesCommonComponent extends SidePanelBase implements OnInit {
    static componentName = "ReviewNotesCommonComponent";


    replyForm: any;

    private _replyFroalaOptions: any = null;
    get replyFroalaOptions(): any {
        if (!this._replyFroalaOptions) {
            this._replyFroalaOptions = applyFroalaAriaFix({
                heightMax: 500,
                height: 500,
                heightMin: 150,
                key: this.editorKey,
                toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough'],
                saveInterval: 0,
                typingTimer: 150,
                autofocus: true
            });
        }
        return this._replyFroalaOptions;
    };
    reviewNotes: Note[];
    

    constructor(private readonly authService: AuthService) { super(); }

    ngOnInit() {
        this.reviewNotes = this.componentData;
    }

    canViewNote(note: any): boolean {
        let canView: boolean = false;
        switch (note.type.toString()) {
            case NoteType.General.toString():
                canView = true;
                break;
            case NoteType.Internal.toString():
            case NoteType.Historical.toString():
                canView = this.authService.User && this.authService.User.isInternal;
                break;
            case NoteType.Administrative.toString():
                canView = note.createdById === this.authService.User.id;
                break;
        }
        return canView;
    }

    openReplyForm(form: any): void {
        form.opened = true;
        form.isReplying = true;
        form.replyText = "";
        this.replyForm = form;
    }

    reply(parentNote: Note, form: any): void {
        form.isDirty = true;
        if (this.replyForm.replyText) {
            const reply = this.createReply(parentNote);
            parentNote.notes.push(reply);
            this.saveMethod.emit(this.reviewNotes);
            this.resetReplyForm(form);
        }
    }

    createReply(parent: Note): Note {
        let reply = deepClone(parent) as Note;
        reply.documentType = "Note";
        reply.isDeleted = false;
        reply.createdDate = undefined;
        reply.createdById = this.authService.User.id;
        reply.createdBy = this.authService.User.displayName;
        reply.text = stripFroalaWatermark(this.replyForm.replyText);
        reply.id = "";
        if (reply.notes) reply.notes = [];
        return reply;
    }

    resetReplyForm(form: any): void {
        form.replyText = "";
        form.isReplying = false;
        form.isDirty = false;
        form.opened = false;
        form.replyText = "";
    }

    toggleReply(replyForm: any): void {
        replyForm.opened = !replyForm.opened;
    }
}
